import { checkHttpStatus, getApiBaseUrl, getApiHeadersFromToken } from '../../../utils/api'
import qs from 'qs'

export const LinkGuardianAccount = async (email, password, token) => {
  try {

    const params = qs.stringify({
      guardian_account: { email_token: token }
    }, { arrayFormat: 'comma', encode: false })

    const url = `${getApiBaseUrl()}/api/guardian_account/link_account`

    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          guardian_account: {
            email: email, password: password, email_token: token
          }
        }),
      })
    )
    return await response.json()

  } catch (error) {
    if (error.response) {
      return await error.response.json()
    } else {
      return new Error()
    }
  }
}

export const validateTokenAPI = async token => {
    try {

      const params = qs.stringify({
        guardian_account: { email_token: token }
      }, { arrayFormat: 'comma', encode: false })

      const url = `${getApiBaseUrl()}/api/guardian_account/validate_invite_token?${params}`

      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET'
        })
      )
      return await response.json()

    } catch (error) {
      return error
    }
}

const validateEmailRequest = async email => {

  try {

    const encodedEmail = encodeURIComponent(email)

    const url = `${getApiBaseUrl()}/api/guardian_account/validate_email?guardian_account[email]=${encodedEmail}`

    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET'
      })
    )

    return await response.json()

  } catch (error) {
    return error
  }
}

export const createGuardianUser = async (email, password, token) => {

  try {

    const url = `${getApiBaseUrl()}/api/guardian_account`

    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          guardian_account: {
            email: email, password: password, email_token: token
          }
        }),
      })
    )

    return await response.json()

  } catch (error) {
    return error
  }
}

export const getPolicies = async token => {

  try {

    const url = `${getApiBaseUrl()}/policies.json`

    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(token)
      })
    )

    return await response.json()

  } catch (error) {
    return error
  }

}

export default validateEmailRequest
